var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"big-box"},[_c('div',{staticClass:"box-border"},[_c('div',{staticClass:"box-title",class:_vm.titleClass},[_c('div',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"box-text",class:_vm.textClass},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }